/* ========================================= */
/* src/pages/MasterClass.tsx - LANDING MASTERCLASS GRATUITA */
/* ========================================= */

import React, { useEffect, useRef } from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { MASTERCLASS_DATETIME } from '../data/masterclass';

import ScrollProgressBar from '../components/masterclass/ScrollProgressBar';
import SectionNav from '../components/masterclass/SectionNav';
import MasterClassHero from '../components/masterclass/MasterClassHero';
import TickerMarquee from '../components/masterclass/TickerMarquee';
import MethodSection from '../components/masterclass/MethodSection';
import ClassBentoSection from '../components/masterclass/ClassBentoSection';
import ForYouSection from '../components/masterclass/ForYouSection';
import AiBanner from '../components/masterclass/AiBanner';
import BeforeAfterSection from '../components/masterclass/BeforeAfterSection';
import InstructorSection from '../components/masterclass/InstructorSection';
import TestimonialsSection from '../components/masterclass/TestimonialsSection';
import RegistrationSection from '../components/masterclass/RegistrationSection';
import NextStepsSection from '../components/masterclass/NextStepsSection';
import FaqSection from '../components/masterclass/FaqSection';
import FinalCtaSection from '../components/masterclass/FinalCtaSection';
import StickyMobileCta from '../components/masterclass/StickyMobileCta';

const MasterClass: React.FC = () => {
  const heroRef = useRef<HTMLElement>(null);
  const countdown = useCountdown(MASTERCLASS_DATETIME);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const id = hash.slice(1);
      const timer = window.setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
      return () => window.clearTimeout(timer);
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative bg-[#070c24] text-white">
      <ScrollProgressBar />
      <SectionNav />

      <main>
        <MasterClassHero ref={heroRef} {...countdown} />
        <TickerMarquee />
        <MethodSection />
        <ClassBentoSection />
        <ForYouSection />
        <AiBanner />
        <BeforeAfterSection />
        <InstructorSection />
        {/*
        <TestimonialsSection />
        */}
        <RegistrationSection fechaLabel={countdown.fechaLabel} horaLabel={countdown.horaLabel} />
        <NextStepsSection />
        <FaqSection />
        <FinalCtaSection {...countdown} />
      </main>

      <StickyMobileCta
        heroRef={heroRef}
        days={countdown.days}
        hours={countdown.hours}
        minutes={countdown.minutes}
        seconds={countdown.seconds}
      />
    </div>
  );
};

export default MasterClass;
